import { useNavigate } from "@tanstack/react-router";
import { Box, Button, Container, Divider, Stack } from "@bookingcom/bui-react";
import { ArrowNavLeftIcon } from "@bookingcom/bui-assets-react/streamline";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { useSelectedAirline } from "../../hooks/useSelectedAirline";
import { useAuth } from "../../hooks/useAuth";
import { AirlinePicker } from "../AirlinePicker";

export const AirlinePickerHeader = () => {
  const i18n = useI18n();
  const navigate = useNavigate();
  const { isAirlineUser } = useAuth();
  const { selectedAirline } = useSelectedAirline();

  const shouldShowBackButton = () => !!selectedAirline;

  if (isAirlineUser) {
    return null;
  }

  return (
    <Container>
      <Box
        mixin={{
          paddingBlockStart: 8,
          paddingBlockEnd: 0,
          paddingInlineStart: 0,
          paddingInlineEnd: 0,
        }}
      >
        <Stack gap={8}>
          <Stack direction="row" alignItems="end" justifyContent="space-between">
            <AirlinePicker
              value={selectedAirline?.code}
              onSubmit={(airline) => {
                navigate({ to: "/metrics", search: { airlineCode: airline.code } });
              }}
            />
            {shouldShowBackButton() && (
              <Button
                variant="secondary"
                size="large"
                icon={ArrowNavLeftIcon}
                text={i18n.trans(t("flights_airline_portal_superuser_back_button"))}
                onClick={() => {
                  navigate({ to: "/overview" });
                }}
              />
            )}
          </Stack>
          <Divider />
        </Stack>
      </Box>
    </Container>
  );
};
